module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/call-bd1ff7c183e4705dd58bf441ee116181.svg";